// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__5MKts","header":"Messages_header__2v50z"};